import ActionState from 'app/enums/ActionState'

export default function(input){

    switch(input){

        case ActionState.PENDING: return '#3498DB';
        case ActionState.IN_PROCESS: return '#F6A623';
        case ActionState.RESOLVED: return '#E74C3C';
        case ActionState.CLOSED: return '#59B147';
        case ActionState.ON_HOLD: return '#2C3E50';
        default: return '';
    }
}